"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconPause = function IconPause(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "9",
    height: "12",
    className: (0, _classnames.default)('Icon', 'IconPause', className),
    style: style
  }, _react.default.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, _react.default.createElement("path", {
    d: "M7.5 0C6.672 0 6 .59 6 1.317v9.366C6 11.41 6.672 12 7.5 12S9 11.41 9 10.683V1.317C9 .59 8.329 0 7.5 0zM1.5 0C.672 0 0 .59 0 1.317v9.366C0 11.41.672 12 1.5 12S3 11.41 3 10.683V1.317C3 .59 2.329 0 1.5 0z"
  })));
};

var _default = IconPause;
exports.default = _default;